import axios from 'axios'
import { Message } from 'view-design'
import store from '@/store/index'
const codeMap = {
  404: '请求地址未找到'
}
const instance = axios.create({
  baseURL: '',
  timeout: 1000 * 60,
  headers: {
    'content-type': 'application/json'
  }
})

instance.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      if (!config.needCache) {
        config.params = config.params || {}
        config.params._t = Date.parse(new Date()) + '_' + Math.random()
      }
    }
    const token = localStorage.getItem('token') || ''
    if (token) {
      config.headers.Authorization = 'Bearer ' + token // 请求头加上token
    }
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      config.headers.Tenantcode = JSON.parse(userInfo).tenantCode
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
) // http response 拦截器
instance.interceptors.response.use(
  response => {
    // 拦截响应，做统一处理
    const { result, data } = response.data
    if (result && result.code === 200) {
      return data
    }
    if (result.code === 10014 || result.code === 10016 || result.code === 200006) {
      // 鉴权失效，执行登录操作
      store.dispatch('logout')
    }
    Toast(result.message || '未知错误')
    return Promise.reject(result)
  },
  // 接口错误状态处理，也就是说无响应时的处理
  error => {
    Toast(codeMap[error.response.status] || '服务异常')
    return Promise.reject(error.response) // 返回接口返回的错误信息
  }
)
export default instance

function Toast(msg) {
  Message.error(msg)
}
